import { Component } from "react";
import { withRouter } from "../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import HeaderWithLogo from "../../../common_components/header_with_logo";
import AdminDrawer from "../../../common_components/admin_module_drawer";
import Footer from "../../../common_components/Footer";
import Pagination from "../../../utils/pagination";
import Select from "react-select";
import JoditEditor from "jodit-react";
import { toastError, toastSuccess, countryActionId, roleTypeActionId, exbTypeActionId, stallTypeActionId, exhibitorTypeActionId, visitorStatusActionId, vsActionID, organizerTypeActionID, agentActionID, DOC_BASE_URL, uploadFeatureIntimationImageUrl } from "../../../utils/constants";
import {
    getTemplateList_action,
    getTemplateById_action,
    saveTemplate_action,
    updateTemplate_action,
    createCampaign_action,
    loadRecipients_action,
    saveRecipients_action,
    sendIntimation_action,
    getExhibitionMailConfig_action,
} from "../../../actions/admin_module_action/feature_intimation_action/feature_intimation_action";
import { fill_action } from "../../../actions/fillCombo_action";

const RECORDS_PER_PAGE = 10;

// Wraps Jodit body content in a full-width email-safe table for storage/sending.
// Email clients need table-based layouts to guarantee 100% width.
const EMAIL_WRAPPER_START = '<table data-itme-email-wrapper="1" width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%;max-width:100%;margin:0;padding:0;border-collapse:collapse;"><tr><td style="padding:16px;">';
const EMAIL_WRAPPER_END   = '</td></tr></table>';

function buildEmailHtml(bodyHtml) {
    return EMAIL_WRAPPER_START + (bodyHtml || '') + EMAIL_WRAPPER_END;
}

// Tables pasted from Excel render with borders in the Jodit editor (via Jodit's
// own stylesheet), but that styling is class/stylesheet based. Email clients
// (Gmail, Outlook, etc.) strip <style> blocks and ignore CSS classes, so the
// borders vanish in the delivered mail. This walks the body HTML and forces
// INLINE border styling onto every table/td/th so the grid survives in email.
function normalizeTablesForEmail(bodyHtml) {
    if (!bodyHtml || typeof window === 'undefined' || !window.DOMParser) return bodyHtml || '';
    if (bodyHtml.indexOf('<table') === -1) return bodyHtml;

    try {
        const doc = new DOMParser().parseFromString(bodyHtml, 'text/html');

        doc.querySelectorAll('table').forEach((table) => {
            // Skip our own full-width wrapper table (border=0 by design).
            if (table.getAttribute('data-itme-email-wrapper') === '1') return;

            const style = (table.getAttribute('style') || '').replace(/\s*$/, '');
            const hasBorder = /(^|;)\s*border\s*:/.test(style) || table.hasAttribute('border');
            table.setAttribute('border', '1');
            table.setAttribute('cellspacing', '0');
            table.setAttribute('cellpadding', '6');
            table.style.borderCollapse = 'collapse';
            if (!hasBorder) table.style.border = '1px solid #cccccc';

            table.querySelectorAll('td, th').forEach((cell) => {
                const cStyle = cell.getAttribute('style') || '';
                if (!/(^|;)\s*border\s*:/.test(cStyle)) {
                    cell.style.border = '1px solid #cccccc';
                }
                if (!/(^|;)\s*padding\s*:/.test(cStyle)) {
                    cell.style.padding = '6px 8px';
                }
            });
        });

        return doc.body.innerHTML;
    } catch (_) {
        return bodyHtml;
    }
}

// Strips our wrapper table when loading stored HtmlContent back into the editor.
function extractBodyFromEmailHtml(storedHtml) {
    if (!storedHtml) return '';
    const si = storedHtml.indexOf(EMAIL_WRAPPER_START);
    if (si === -1) return storedHtml;
    const contentStart = si + EMAIL_WRAPPER_START.length;
    const ei = storedHtml.lastIndexOf(EMAIL_WRAPPER_END);
    if (ei === -1 || ei <= contentStart) return storedHtml;
    return storedHtml.substring(contentStart, ei);
}

class FeatureIntimationAU extends Component {
    editorConfig = {
        readonly: false,
        toolbar: true,
        spellcheck: true,
        language: "en",
        toolbarButtonSize: "medium",
        toolbarAdaptive: false,
        showCharsCounter: false,
        showWordsCounter: false,
        showXPathInStatusbar: false,
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        uploader: {
            url: uploadFeatureIntimationImageUrl,
            format: 'json',
            method: 'POST',
            insertImageAsBase64URI: false,
            process(resp) {
                return {
                    files: resp.data ? [resp.data] : [],
                    baseurl: DOC_BASE_URL,
                    error: resp.error || 0,
                    msg: resp.msg || '',
                };
            },
            isSuccess(resp) { return resp && resp.error === 0; },
            getMessage(resp) { return resp.msg; },
            defaultHandlerSuccess(data) {
                const editor = this;
                if (data.files && data.files.length) {
                    data.files.forEach(function (filename) {
                        editor.selection.insertImage(data.baseurl + filename);
                    });
                }
            },
        },
        height: 400,
    };
    constructor(props) {
        super(props);
        this.state = {
            isLoading:        false,

            // Communication details
            subject:          '',
            selectedTemplate: '',
            templateList:     [],
            mailBodyHtml:     '',

            // Save as template
            templateName:     '',
            showTemplateSave: false,

            // Recipient type checkboxes
            inclExhibitor:    false,
            inclVisitor:      false,
            inclDelegate:     false,
            inclVendor:       false,
            inclOrganiser:    false,

            // Exhibitor filters
            selectedExhTypeIds: [],   // numeric Code IDs from exhTypeList
            exhNatDomestic:     false,
            exhNatIntl:         false,
            exhSchemeBare:      false,
            exhSchemeShell:     false,

            // Visitor filters
            selectedVisTypes:   [],   // Name strings: 'Complete', 'Incomplete'
            visNatDomestic:     false,
            visNatIntl:         false,

            // Delegate filters
            delegateCountry:   [],
            countryList:       [],

            // Recipient type options (from fill_action)
            roleTypeList:      [],
            exhTypeList:       [],
            stallTypeList:     [],
            nationalityList:   [],
            visitorStatusList: [],

            // Vendor filters
            vendorService:     [],
            vendorServiceList: [],

            // Organiser filters
            selectedOrgTypeIds: [],
            organiserTypeList:  [],

            // Agent filters
            selectedAgentIds:   [],
            agentList:          [],

            exhibitionID:     sessionStorage.getItem('sessionExhibitionID') || '',

            // Recipients table
            recipientList:    [],
            filteredList:     [],
            recipientSearch:  '',
            selectAll:        false,
            currentPage:      1,

            subjectErr:       '',
            mailBodyErr:      '',

            // Send preview modal
            showSendModal:    false,
            mailHeaderPath:   '',
            mailFooterPath:   '',
        };

        this.handleEditorChange    = this.handleEditorChange.bind(this);
        this.handleTemplateChange  = this.handleTemplateChange.bind(this);
        this.handleLoadRecipients  = this.handleLoadRecipients.bind(this);
        this.handleSelectAll       = this.handleSelectAll.bind(this);
        this.handleRowSelect       = this.handleRowSelect.bind(this);
        this.handleRecipientSearch = this.handleRecipientSearch.bind(this);
        this.handleSave            = this.handleSave.bind(this);
        this.handleSaveTemplate    = this.handleSaveTemplate.bind(this);
        this.handleUpdateTemplate  = this.handleUpdateTemplate.bind(this);
        this.openSendPreview       = this.openSendPreview.bind(this);
        this.handleConfirmSend     = this.handleConfirmSend.bind(this);
        this.setCurrentPage        = this.setCurrentPage.bind(this);
        this.validate              = this.validate.bind(this);
    }

    componentDidMount() {
        this.loadDropdowns();
    }

    loadDropdowns() {
        const loginData  = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const { exhibitionID } = this.state;

        this.props.getTemplateList_action(exhibitionID || null, loginData.UserID || null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ templateList: data.data || [] });
                }
            });

        this.props.fill_action(roleTypeActionId, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ roleTypeList: data.data || [] });
                }
            });

        this.props.fill_action(exbTypeActionId, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ exhTypeList: data.data || [] });
                }
            });

        this.props.fill_action(stallTypeActionId, exhibitionID || null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ stallTypeList: data.data || [] });
                }
            });

        this.props.fill_action(exhibitorTypeActionId, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ nationalityList: data.data || [] });
                }
            });

        this.props.fill_action(visitorStatusActionId, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ visitorStatusList: data.data || [] });
                }
            });

        this.props.fill_action(countryActionId, exhibitionID || null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ countryList: (data.data || []).map(c => ({ label: c.Description, value: c.Code })) });
                }
            });

        this.props.fill_action(vsActionID, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ vendorServiceList: (data.data || []).map(s => ({ label: s.Description, value: s.Code })) });
                }
            });

        this.props.fill_action(organizerTypeActionID, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    this.setState({ organiserTypeList: data.data || [] });
                }
            });

        this.props.fill_action(agentActionID, null, null, null, null, null)
            .then(data => {
                if (data && data.error !== 1) {
                    console.log('agentList sample:', data.data && data.data[0]);
                    this.setState({ agentList: data.data || [] });
                }
            });
    }

    handleEditorChange(newContent) {
        this.setState({ mailBodyHtml: newContent, mailBodyErr: '' });
    }

    handleTemplateChange(e) {
        const tID = e.target.value;
        this.setState({ selectedTemplate: tID, showTemplateSave: false, templateName: '' });
        if (!tID) return;
        this.setState({ isLoading: true });
        this.props.getTemplateById_action(tID)
            .then(data => {
                this.setState({ isLoading: false });
                if (data && data.error !== 1 && data.data && data.data[0]) {
                    const tpl = data.data[0];
                    this.setState({ subject: tpl.Subject || '', mailBodyHtml: extractBodyFromEmailHtml(tpl.HtmlContent || '') });
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    validate() {
        let valid = true;
        if (!this.state.subject.trim()) {
            this.setState({ subjectErr: 'Subject is required.' });
            valid = false;
        }
        if (!this.state.mailBodyHtml.trim()) {
            this.setState({ mailBodyErr: 'Mail content is required.' });
            valid = false;
        }
        return valid;
    }

    handleLoadRecipients() {
        const {
            inclExhibitor, selectedExhTypeIds,
            exhNatDomestic, exhNatIntl, exhSchemeBare, exhSchemeShell,
            selectedAgentIds,
            inclVisitor, selectedVisTypes, visNatDomestic, visNatIntl,
            inclDelegate, delegateCountry,
            inclVendor, vendorService,
            inclOrganiser, selectedOrgTypeIds,
            exhibitionID,
        } = this.state;

        if (!inclExhibitor && !inclVisitor && !inclDelegate && !inclVendor && !inclOrganiser) {
            toastError('Please select at least one recipient type.');
            return;
        }

        // SP uses STRING_SPLIT on comma-separated numeric IDs (1,2,4,5,6,7,8)
        const exhType   = selectedExhTypeIds.length ? selectedExhTypeIds.join(',') : null;
        // SP uses CHARINDEX / STRING_SPLIT for 'National' / 'International'
        const exhNatArr = [...(exhNatDomestic ? ['National'] : []), ...(exhNatIntl ? ['International'] : [])];
        const exhNat    = exhNatArr.length ? exhNatArr.join(',') : null;
        const exhScheme = (exhSchemeBare && exhSchemeShell) ? 'Bare,Shell' : exhSchemeBare ? 'Bare' : exhSchemeShell ? 'Shell' : null;
        // SP uses STRING_SPLIT for 'Complete' / 'Incomplete'
        const visType   = selectedVisTypes.length ? selectedVisTypes.join(',') : null;
        const visNatArr = [...(visNatDomestic ? ['National'] : []), ...(visNatIntl ? ['International'] : [])];
        const visNat    = visNatArr.length ? visNatArr.join(',') : null;

        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const payload = {
            ExhibitionID:      exhibitionID || null,
            UserID:            loginData.UserID || null,
            IncludeExhibitor:  inclExhibitor,
            ExhibitorType:     inclExhibitor ? exhType   : null,
            ExhNationality:    inclExhibitor ? exhNat    : null,
            ExhScheme:         inclExhibitor ? exhScheme : null,
            IncludeVisitor:    inclVisitor,
            VisitorType:       inclVisitor ? visType : null,
            VisNationality:    inclVisitor ? visNat  : null,
            IncludeDelegate:    inclDelegate,
            DelegateCountryIDs: inclDelegate && delegateCountry.length ? delegateCountry.map(c => c.value).join(',') : null,
            IncludeVendor:      inclVendor,
            VendorServiceIDs:   inclVendor && vendorService.length ? vendorService.map(s => s.value).join(',') : null,
            IncludeOrganiser:   inclOrganiser,
            OrganiserTypeIDs:   inclOrganiser && selectedOrgTypeIds.length ? selectedOrgTypeIds.join(',') : null,
            AgentIDs:           inclExhibitor && selectedAgentIds.length ? selectedAgentIds.join(',') : null,
        };

        this.setState({ isLoading: true });
        this.props.loadRecipients_action(payload)
            .then(data => {
                this.setState({ isLoading: false });
                if (data && data.error !== 1) {
                    const list = (data.data || []).map(r => ({ ...r, selected: false }));
                    this.setState({
                        recipientList: list, filteredList: list,
                        selectAll: false, currentPage: 1, recipientSearch: '',
                    });
                    toastSuccess(`Loaded ${list.length} recipient(s).`);
                } else {
                    toastError(data && data.msg ? data.msg : 'Failed to load recipients.');
                }
            })
            .catch(() => this.setState({ isLoading: false }));
    }

    handleSelectAll(e) {
        const checked = e.target.checked;
        this.setState({ filteredList: this.state.filteredList.map(r => ({ ...r, selected: checked })), selectAll: checked });
    }

    handleRowSelect(idx) {
        const updated = [...this.state.filteredList];
        updated[idx] = { ...updated[idx], selected: !updated[idx].selected };
        this.setState({ filteredList: updated, selectAll: updated.every(r => r.selected) });
    }

    handleRecipientSearch(e) {
        const q = e.target.value.toLowerCase();
        const filtered = this.state.recipientList.filter(r =>
            (r.name  || '').toLowerCase().includes(q) ||
            (r.email || '').toLowerCase().includes(q)
        );
        this.setState({ recipientSearch: e.target.value, filteredList: filtered, currentPage: 1 });
    }

    async resolveTemplateID() {
        const { subject, mailBodyHtml, exhibitionID, selectedTemplate } = this.state;
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');

        // If a template is already selected, persist any edits the user made to
        // the subject/body back to that template before using it.
        if (selectedTemplate) {
            const tpl = this.state.templateList.find(
                t => String(t.FeaIntimationTemplateID) === String(selectedTemplate)
            );
            const updRes = await this.props.updateTemplate_action({
                TemplateID:   selectedTemplate,
                TemplateName: tpl ? tpl.TemplateName : '',
                Subject:      subject,
                HtmlContent:  normalizeTablesForEmail(mailBodyHtml),
                ModifiedBy:   loginData.UserID || null,
            });
            if (!updRes || updRes.error === 1) {
                throw new Error(updRes ? updRes.msg : 'Failed to update template.');
            }
            return selectedTemplate;
        }

        // Otherwise auto-save current content as a new template
        const autoName  = `${subject || 'Intimation'} - ${new Date().toLocaleDateString('en-IN')}`;

        const tplRes = await this.props.saveTemplate_action({
            ExhibitionID: exhibitionID,
            TemplateName: autoName,
            Subject:      subject,
            HtmlContent:  normalizeTablesForEmail(mailBodyHtml),
            CreatedBy:    loginData.UserID || 0,
        });

        if (!tplRes || tplRes.error === 1) {
            throw new Error(tplRes ? tplRes.msg : 'Failed to save template.');
        }
        // Refresh template list and pre-select the new template
        this.setState({ selectedTemplate: tplRes.data });
        this.loadDropdowns();
        return tplRes.data;
    }

    async handleSave() {
        if (!this.validate()) return;

        const { exhibitionID, filteredList } = this.state;

        const selected = filteredList.filter(r => r.selected);
        if (selected.length === 0) {
            toastError('Please load and select at least one recipient before saving.');
            return;
        }
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');

        this.setState({ isLoading: true });
        try {
            const templateID = await this.resolveTemplateID();

            const res = await this.props.createCampaign_action({
                ExhibitionID: exhibitionID,
                TemplateID:   templateID,
                CreatedBy:    loginData.UserID || 0,
            });
            if (!res || res.error === 1) {
                this.setState({ isLoading: false });
                toastError(res ? res.msg : 'Failed to create campaign.');
                return;
            }

            await this.props.saveRecipients_action({ CampaignID: res.data, recipients: selected });

            this.setState({ isLoading: false });
            toastSuccess('Campaign saved successfully.');
            setTimeout(() => this.props.navigate('/featureIntimationList'), 1200);
        } catch (err) {
            this.setState({ isLoading: false });
            toastError(err.message || 'An error occurred while saving.');
        }
    }

    async openSendPreview() {
        if (!this.validate()) return;

        const selected = this.state.filteredList.filter(r => r.selected);
        if (selected.length === 0) {
            toastError('Please load and select at least one recipient before sending.');
            return;
        }

        const { exhibitionID } = this.state;
        this.setState({ isLoading: true });
        try {
            const cfgRes = await this.props.getExhibitionMailConfig_action(exhibitionID);
            const cfg = (cfgRes && cfgRes.error !== 1 && cfgRes.data) ? cfgRes.data : {};
            this.setState({
                isLoading:     false,
                mailHeaderPath: cfg.MailHeaderPath || '',
                mailFooterPath: cfg.MailFooterPath || '',
                showSendModal:  true,
            });
        } catch (_) {
            this.setState({ isLoading: false, mailHeaderPath: '', mailFooterPath: '', showSendModal: true });
        }
    }

    async handleConfirmSend() {
        this.setState({ showSendModal: false });

        const selected = this.state.filteredList.filter(r => r.selected);
        const { exhibitionID } = this.state;
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');

        this.setState({ isLoading: true });
        try {
            const templateID = await this.resolveTemplateID();

            const res = await this.props.createCampaign_action({
                ExhibitionID: exhibitionID,
                TemplateID:   templateID,
                CreatedBy:    loginData.UserID || 0,
            });
            if (!res || res.error === 1) {
                this.setState({ isLoading: false });
                toastError(res ? res.msg : 'Failed to create campaign.');
                return;
            }

            await this.props.saveRecipients_action({ CampaignID: res.data, recipients: selected });

            const sendRes = await this.props.sendIntimation_action({
                CampaignID:   res.data,
                ExhibitionID: exhibitionID,
            });

            this.setState({ isLoading: false });
            if (sendRes && sendRes.error !== 1) {
                toastSuccess(sendRes.msg || 'Emails queued for sending.');
                setTimeout(() => this.props.navigate('/featureIntimationList'), 1500);
            } else {
                toastError(sendRes ? sendRes.msg : 'Failed to send intimation.');
            }
        } catch (err) {
            this.setState({ isLoading: false });
            toastError(err.message || 'An error occurred while sending.');
        }
    }

    handleUpdateTemplate() {
        const { selectedTemplate, subject, mailBodyHtml } = this.state;
        if (!subject.trim()) { toastError('Subject is required to update template.'); return; }
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        const tpl = this.state.templateList.find(t => String(t.FeaIntimationTemplateID) === String(selectedTemplate));
        this.setState({ isLoading: true });
        this.props.updateTemplate_action({
            TemplateID:   selectedTemplate,
            TemplateName: tpl ? tpl.TemplateName : '',
            Subject:      subject,
            HtmlContent:  normalizeTablesForEmail(mailBodyHtml),
            ModifiedBy:   loginData.UserID || null,
        }).then(data => {
            this.setState({ isLoading: false });
            if (data && data.error !== 1) {
                toastSuccess('Template updated successfully.');
                this.loadDropdowns();
            } else {
                toastError(data ? data.msg : 'Failed to update template.');
            }
        }).catch(() => this.setState({ isLoading: false }));
    }

    handleSaveTemplate() {
        const { templateName, subject, mailBodyHtml, exhibitionID } = this.state;
        if (!templateName.trim()) { toastError('Please enter a template name.'); return; }
        if (!subject.trim())      { toastError('Subject is required to save template.'); return; }
        const loginData = JSON.parse(sessionStorage.getItem('loginDataSS') || '{}');
        this.setState({ isLoading: true });
        this.props.saveTemplate_action({
            ExhibitionID: exhibitionID,
            TemplateName: templateName,
            Subject:      subject,
            HtmlContent:  normalizeTablesForEmail(mailBodyHtml),
            CreatedBy:    loginData.UserID || 0,
        }).then(data => {
            this.setState({ isLoading: false, showTemplateSave: false, templateName: '' });
            if (data && data.error !== 1) {
                toastSuccess('Template saved successfully.');
                this.loadDropdowns();
            } else {
                toastError(data ? data.msg : 'Failed to save template.');
            }
        }).catch(() => this.setState({ isLoading: false }));
    }

    setCurrentPage(page) { this.setState({ currentPage: page }); }

    render() {
        const {
            isLoading, subject, subjectErr, mailBodyHtml, mailBodyErr,
            templateList, selectedTemplate,
            showTemplateSave, templateName,
            inclExhibitor, inclVisitor, inclDelegate, inclVendor, inclOrganiser,
            selectedExhTypeIds, exhNatDomestic, exhNatIntl, exhSchemeBare, exhSchemeShell,
            selectedVisTypes, visNatDomestic, visNatIntl,
            delegateCountry, countryList,
            vendorService, vendorServiceList,
            roleTypeList, exhTypeList, stallTypeList, nationalityList, visitorStatusList, organiserTypeList,
            selectedOrgTypeIds,
            agentList, selectedAgentIds,
            filteredList, recipientSearch, selectAll,
            currentPage,
            showSendModal, mailHeaderPath, mailFooterPath,
        } = this.state;

        // Map each roleType Description to the matching inclXxx state key
        const descToKey = (desc) => {
            const d = (desc || '').toLowerCase();
            if (d.includes('exhibitor'))  return 'inclExhibitor';
            if (d.includes('visitor'))    return 'inclVisitor';
            if (d.includes('delegate'))   return 'inclDelegate';
            if (d.includes('vendor'))     return 'inclVendor';
            if (d.includes('organiser') || d.includes('organizer')) return 'inclOrganiser';
            return null;
        };

        const toggleExhTypeId = (code, checked) => {
            const id = Number(code);
            const next = checked
                ? [...selectedExhTypeIds.filter(x => Number(x) !== id), id]
                : selectedExhTypeIds.filter(x => Number(x) !== id);
            this.setState({ selectedExhTypeIds: next });
        };

        // Map each stall type Description to the matching exhSchemeXxx state key
        const stallTypeDescToKey = (desc) => {
            const d = (desc || '').toLowerCase();
            if (d.includes('bare'))  return 'exhSchemeBare';
            if (d.includes('shell')) return 'exhSchemeShell';
            return null;
        };

        // Map nationality ExhibitorType to state key using a prefix (exhNat / visNat)
        const natDescToKey = (desc, prefix) => {
            const d = (desc || '').toLowerCase();
            if (d.includes('international'))               return `${prefix}Intl`;
            if (d.includes('national') || d.includes('domestic')) return `${prefix}Domestic`;
            return null;
        };

        const toggleVisType = (name, checked) => {
            const next = checked
                ? [...selectedVisTypes, name]
                : selectedVisTypes.filter(n => n !== name);
            this.setState({ selectedVisTypes: next });
        };

        const selectedCount = filteredList.filter(r => r.selected).length;
        const previewHtml = `<!DOCTYPE html><html><head><meta charset="utf-8"/>
            <style>body{margin:0;padding:0;background:#fff;}table{border-collapse:collapse;}td{word-break:break-word;}img{border:0;outline:none;display:block;}</style>
            </head><body style="margin:0;padding:0;background:#fff;">
            <table role="presentation" width="100%" cellpadding="0" cellspacing="0" border="0" style="width:100%;background:#fff;">
              <tr><td style="padding:0;line-height:0;font-size:0;">
                ${mailHeaderPath ? `<img src="${DOC_BASE_URL}${mailHeaderPath}" alt="Header" style="width:100%;height:auto;display:block;"/>` : ''}
              </td></tr>
              <tr><td style="padding:24px 32px;font-family:Arial,Helvetica,sans-serif;font-size:14px;color:#333333;line-height:1.6;">
                ${normalizeTablesForEmail(mailBodyHtml)}
              </td></tr>
              <tr><td style="padding:0;line-height:0;font-size:0;">
                ${mailFooterPath ? `<img src="${DOC_BASE_URL}${mailFooterPath}" alt="Footer" style="width:100%;height:auto;display:block;"/>` : ''}
              </td></tr>
            </table>
            </body></html>`;

        const indexOfLast  = currentPage * RECORDS_PER_PAGE;
        const indexOfFirst = indexOfLast - RECORDS_PER_PAGE;
        const pageRows     = filteredList.slice(indexOfFirst, indexOfLast);
        const nPages       = Math.ceil(filteredList.length / RECORDS_PER_PAGE);

        return (
            <>
                <ToastContainer />
                {isLoading ? <Loader /> : null}
                <HeaderWithLogo />
                <div className="app-content with-dr-container">
                    <AdminDrawer />
                    <div className="breadcrumb-scroll-fixed">
                        <h6 className="mb-0 p-2 text-white">Notification — Create New</h6>
                    </div>
                    <div className="admin-top-space p-2">

                        {/* ── Card 1: Communication Details ── */}
                        <div className="card mb-3">
                            <div className="card-header fw-semibold">Communication Details</div>
                            <div className="card-body">
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Subject <span className="text-red">*</span></label>
                                        <input
                                            type="text"
                                            className={`form-control ${subjectErr ? 'is-invalid' : ''}`}
                                            placeholder="Enter email subject"
                                            value={subject}
                                            onChange={e => this.setState({ subject: e.target.value, subjectErr: '' })}
                                        />
                                        {subjectErr && <div className="invalid-feedback">{subjectErr}</div>}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="form-label">Select Template</label>
                                        <select
                                            className="form-control"
                                            value={selectedTemplate}
                                            onChange={this.handleTemplateChange}
                                        >
                                            <option value="">-- Select Template (Optional) --</option>
                                            {templateList.map(t => (
                                                <option key={t.FeaIntimationTemplateID} value={t.FeaIntimationTemplateID}>{t.TemplateName}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                <div className="mb-2">
                                    <label className="form-label">Mail Content <span className="text-red">*</span></label>
                                    <JoditEditor
                                        value={mailBodyHtml}
                                        config={this.editorConfig}
                                        onChange={this.handleEditorChange}
                                    />
                                    {mailBodyErr && <div className="text-danger small mt-1">{mailBodyErr}</div>}
                                </div>

                                <div className="mt-2">
                                    {selectedTemplate ? (
                                        <button className="btn btn-blue btn-sm" onClick={this.handleUpdateTemplate}>
                                            Update Template
                                        </button>
                                    ) : !showTemplateSave ? (
                                        <button className="btn btn-blue btn-sm" onClick={() => this.setState({ showTemplateSave: true })}>
                                            Save as Template
                                        </button>
                                    ) : (
                                        <div className="d-flex align-items-center gap-2 mt-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Template name"
                                                style={{ maxWidth: 280 }}
                                                value={templateName}
                                                onChange={e => this.setState({ templateName: e.target.value })}
                                            />
                                            <button className="btn btn-aqua btn-sm" onClick={this.handleSaveTemplate}>Save</button>
                                            <button className="btn btn-gray btn-sm" onClick={() => this.setState({ showTemplateSave: false, templateName: '' })}>Cancel</button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* ── Card 2: Recipient Selection ── */}
                        <div className="card mb-3">
                            <div className="card-header fw-semibold">Recipient Selection</div>
                            <div className="card-body">
                                <div className="d-flex gap-4 mb-3 flex-wrap">
                                    {roleTypeList.map(r => {
                                        const stateKey = descToKey(r.Description);
                                        if (!stateKey) return null;
                                        return (
                                            <div key={r.Code} className="form-check form-check-inline">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    id={stateKey}
                                                    checked={this.state[stateKey]}
                                                    onChange={e => this.setState({ [stateKey]: e.target.checked })}
                                                />
                                                <label className="form-check-label" htmlFor={stateKey}>{r.Description}</label>
                                            </div>
                                        );
                                    })}
                                </div>

                                {inclExhibitor && (
                                    <div className="border rounded p-3 mb-3">
                                        <h6 className="mb-2 text-muted">Exhibitor Filters</h6>
                                        <div className="row">
                                            <div className="col-md-4">
                                                <label className="form-label fw-semibold">Payment Type</label>
                                                {exhTypeList.map(r => (
                                                    <div key={r.Code} className="form-check">
                                                        <input type="checkbox" className="form-check-input" id={`exht_${r.Code}`}
                                                            checked={selectedExhTypeIds.map(Number).includes(Number(r.Code))}
                                                            onChange={e => toggleExhTypeId(r.Code, e.target.checked)} />
                                                        <label className="form-check-label" htmlFor={`exht_${r.Code}`}>{r.Description}</label>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-semibold">Nationality</label>
                                                {nationalityList.map(r => {
                                                    const stateKey = natDescToKey(r.ExhibitorType, 'exhNat');
                                                    if (!stateKey) return null;
                                                    return (
                                                        <div key={r.ID} className="form-check">
                                                            <input type="checkbox" className="form-check-input" id={`exh_${stateKey}`}
                                                                checked={this.state[stateKey]}
                                                                onChange={e => this.setState({ [stateKey]: e.target.checked })} />
                                                            <label className="form-check-label" htmlFor={`exh_${stateKey}`}>{r.ExhibitorType}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-semibold">Stall Scheme</label>
                                                {stallTypeList.map(r => {
                                                    const stateKey = stallTypeDescToKey(r.Description);
                                                    if (!stateKey) return null;
                                                    return (
                                                        <div key={r.Code} className="form-check">
                                                            <input type="checkbox" className="form-check-input" id={stateKey}
                                                                checked={this.state[stateKey]}
                                                                onChange={e => this.setState({ [stateKey]: e.target.checked })} />
                                                            <label className="form-check-label" htmlFor={stateKey}>{r.Description}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                            <div className="col-md-4">
                                                <label className="form-label fw-semibold">Agent</label>
                                                {agentList.map(r => {
                                                    const id = String(r.Code);
                                                    return (
                                                        <div key={id} className="form-check">
                                                            <input type="checkbox" className="form-check-input" id={`agent_${id}`}
                                                                checked={selectedAgentIds.includes(id)}
                                                                onChange={e => {
                                                                    const next = e.target.checked
                                                                        ? [...selectedAgentIds.filter(x => x !== id), id]
                                                                        : selectedAgentIds.filter(x => x !== id);
                                                                    this.setState({ selectedAgentIds: next });
                                                                }} />
                                                            <label className="form-check-label" htmlFor={`agent_${id}`}>{r.Description}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {inclVisitor && (
                                    <div className="border rounded p-3 mb-3">
                                        <h6 className="mb-2 text-muted">Visitor Filters</h6>
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">Visitor Type</label>
                                                {visitorStatusList.map(r => (
                                                    <div key={r.ID} className="form-check">
                                                        <input type="checkbox" className="form-check-input" id={`vist_${r.ID}`}
                                                            checked={selectedVisTypes.includes(r.Name)}
                                                            onChange={e => toggleVisType(r.Name, e.target.checked)} />
                                                        <label className="form-check-label" htmlFor={`vist_${r.ID}`}>{r.Name}</label>
                                                    </div>
                                                ))}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-semibold">Nationality</label>
                                                {nationalityList.map(r => {
                                                    const stateKey = natDescToKey(r.ExhibitorType, 'visNat');
                                                    if (!stateKey) return null;
                                                    return (
                                                        <div key={r.ID} className="form-check">
                                                            <input type="checkbox" className="form-check-input" id={`vis_${stateKey}`}
                                                                checked={this.state[stateKey]}
                                                                onChange={e => this.setState({ [stateKey]: e.target.checked })} />
                                                            <label className="form-check-label" htmlFor={`vis_${stateKey}`}>{r.ExhibitorType}</label>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {inclDelegate && (
                                    <div className="border rounded p-3 mb-3">
                                        <h6 className="mb-2 text-muted">Delegate Filters</h6>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold">Country</label>
                                            <Select
                                                isMulti
                                                options={countryList}
                                                value={delegateCountry}
                                                onChange={v => this.setState({ delegateCountry: v || [] })}
                                                placeholder="Search country..."
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                )}

                                {inclVendor && (
                                    <div className="border rounded p-3 mb-3">
                                        <h6 className="mb-2 text-muted">Vendor Filters</h6>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold">Service</label>
                                            <Select
                                                isMulti
                                                options={vendorServiceList}
                                                value={vendorService}
                                                onChange={v => this.setState({ vendorService: v || [] })}
                                                placeholder="Search service..."
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                )}

                                {inclOrganiser && (
                                    <div className="border rounded p-3 mb-3">
                                        <h6 className="mb-2 text-muted">Organiser Filters</h6>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold">Organiser Type</label>
                                            {organiserTypeList.map(r => (
                                                <div key={r.RoleID} className="form-check">
                                                    <input type="checkbox" className="form-check-input" id={`orgt_${r.RoleID}`}
                                                        checked={selectedOrgTypeIds.map(Number).includes(Number(r.RoleID))}
                                                        onChange={e => {
                                                            const id = Number(r.RoleID);
                                                            const next = e.target.checked
                                                                ? [...this.state.selectedOrgTypeIds.filter(x => Number(x) !== id), id]
                                                                : this.state.selectedOrgTypeIds.filter(x => Number(x) !== id);
                                                            this.setState({ selectedOrgTypeIds: next });
                                                        }} />
                                                    <label className="form-check-label" htmlFor={`orgt_${r.RoleID}`}>{r.RoleName}</label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <button className="btn btn-aqua" onClick={this.handleLoadRecipients}>
                                    Load Recipients
                                </button>
                            </div>
                        </div>

                        {/* ── Card 3: Recipient Preview ── */}
                        {filteredList.length >= 0 && (
                            <div className="card mb-3">
                                <div className="card-header d-flex justify-content-between align-items-center">
                                    <span className="fw-semibold">Recipient Preview</span>
                                    <small className="text-muted">
                                        Total: {filteredList.length} &nbsp;|&nbsp; Selected: {selectedCount}
                                    </small>
                                </div>
                                <div className="card-body">
                                    <div className="mb-2" style={{ maxWidth: 320 }}>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            placeholder="Search.."
                                            value={recipientSearch}
                                            onChange={this.handleRecipientSearch}
                                        />
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered sticky-table text-nowrap">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>
                                                        <input type="checkbox" checked={selectAll} onChange={this.handleSelectAll} />
                                                    </th>
                                                    <th>Sr No.</th>
                                                    <th>Application No</th>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Type</th>
                                                    {/* <th>Info</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {pageRows.length > 0 ? pageRows.map((r, i) => (
                                                    <tr key={i}>
                                                        <td>
                                                            <input
                                                                type="checkbox"
                                                                checked={r.selected || false}
                                                                onChange={() => this.handleRowSelect(indexOfFirst + i)}
                                                            />
                                                        </td>
                                                        <td>{indexOfFirst + i + 1}</td>
                                                        <td>{r.ExhRegistrationNo  || '-'}</td>
                                                        <td>{r.name  || '-'}</td>
                                                        <td>{r.email || '-'}</td>
                                                        <td>{r.recipient_type}</td>
                                                        {/* <td className="text-muted">{r.extra_info || '-'}</td> */}
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="7" className="text-center">
                                                            {filteredList.length === 0
                                                                ? 'Click "Load Recipients" to preview.'
                                                                : 'No records match the search.'}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <Pagination
                                        nPages={nPages}
                                        currentPage={currentPage}
                                        setCurrentPage={this.setCurrentPage}
                                    />
                                </div>
                            </div>
                        )}

                        {/* ── Footer Actions ── */}
                        <div className="d-flex gap-2 mt-2 pb-4">
                            <button className="btn btn-aqua" onClick={this.handleSave}>Save</button>
                            <button className="btn btn-aqua" onClick={this.openSendPreview}>Send Intimation</button>
                            <button className="btn btn-gray ms-auto" onClick={() => this.props.navigate('/featureIntimationList')}>Cancel</button>
                        </div>

                    </div>
                </div>
                {/* ── Send Confirmation Modal ── */}
                {showSendModal && (
                    <div style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.65)', zIndex: 99999,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}>
                        <div style={{
                            background: '#fff', borderRadius: 8,
                            width: '80%', maxWidth: 820, maxHeight: '88vh',
                            display: 'flex', flexDirection: 'column', overflow: 'hidden',
                        }}>
                            <div className="p-3 d-flex justify-content-between align-items-center" style={{ background: '#3dbca7', flexShrink: 0 }}>
                                <h5 className="text-white mb-0" style={{ fontSize: 16 }}>Email Preview — {subject}</h5>
                                <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ showSendModal: false })} />
                            </div>
                            <div className="p-2 bg-light" style={{ fontSize: 13, flexShrink: 0 }}>
                                <span className="text-muted">
                                    Sending to <strong>{selectedCount}</strong> recipient(s). Review the email below before confirming.
                                </span>
                            </div>
                            <div style={{ flex: 1, overflow: 'auto' }}>
                                <iframe
                                    title="email-preview"
                                    srcDoc={previewHtml}
                                    style={{ width: '100%', minHeight: 460, border: 'none', display: 'block' }}
                                />
                            </div>
                            <div className="p-2 d-flex justify-content-end gap-2" style={{ borderTop: '1px solid #dee2e6', flexShrink: 0 }}>
                                <button className="btn btn-gray btn-sm" onClick={() => this.setState({ showSendModal: false })}>Cancel</button>
                                <button className="btn btn-aqua btn-sm" onClick={this.handleConfirmSend}>Confirm &amp; Send</button>
                            </div>
                        </div>
                    </div>
                )}

                <Footer />
            </>
        );
    }
}

export default withRouter(connect(null, {
    getTemplateList_action,
    getTemplateById_action,
    saveTemplate_action,
    updateTemplate_action,
    createCampaign_action,
    loadRecipients_action,
    saveRecipients_action,
    sendIntimation_action,
    getExhibitionMailConfig_action,
    fill_action,
})(FeatureIntimationAU));
